// DUCK FORMATTING FOR REDUCERS
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    SEARCH_TAB_NAMES: { PARKS, PLACES, ALL, TRAILS, MAPS, RECORDINGS, LISTS }
  }
} = StringConstantsMixin;

export const UPDATE_QUERY_TEXT = 'UPDATE_QUERY_TEXT';
export const POPULATE_SEARCH_RESULTS = 'POPULATE_SEARCH_RESULTS';
export const UPDATE_ACTIVE_TAB_FILTER = 'UPDATE_ACTIVE_TAB_FILTER';
export const UPDATE_ENGAGED_STATE = 'UPDATE_ENGAGED_STATE';
export const UPDATE_ACTIVE_RESULT_INDEX = 'UPDATE_ACTIVE_RESULT_INDEX';

export const initialSearchState = {
  results: [],
  query: '',
  filters: [
    { key: 'all', label: ALL },
    { key: 'area', label: PARKS },
    { key: 'place', label: PLACES },
    { key: 'trail', label: TRAILS },
    { key: 'map', label: MAPS },
    { key: 'track', label: RECORDINGS },
    { key: 'list', label: LISTS }
  ],
  activeFilterIndex: 0,
  engaged: false,
  activeIndexResult: null,
  queryID: null,
  loading: false
};

// Each dispatch to the reducer will make a copy of the current state
// using the spread operator with an update depending on the action.type
// with a value that is inside action.payload. Actions are usually shaped
// like { type: POPULATE_SEARCH_RESULTS, payload: some payload }
const searchReducer = (state = initialSearchState, action) => {
  switch (action.type) {
    case UPDATE_QUERY_TEXT:
      return {
        ...state,
        query: action.payload,
        engaged: true,
        loading: true
      };
    case POPULATE_SEARCH_RESULTS: {
      return {
        ...state,
        results: action.payload.results,
        queryID: action.payload.queryID,
        activeIndexResult: 0,
        loading: false
      };
    }
    case UPDATE_ACTIVE_TAB_FILTER: {
      return {
        ...state,
        activeFilterIndex: action.payload
      };
    }
    case UPDATE_ENGAGED_STATE: {
      return {
        ...state,
        engaged: action.payload
      };
    }
    case UPDATE_ACTIVE_RESULT_INDEX: {
      return {
        ...state,
        activeIndexResult: action.payload
      };
    }
    default:
      return state;
  }
};

export default searchReducer;
